<template>
  <layout-default-appbar :back-to="rotacadastro" filterable>
    Frota
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

import { ROUTE_CADASTRO } from '@/constants/ROUTES';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
      rotacadastro: ROUTE_CADASTRO,
    };
  },
};
</script>
